module.exports = "<div class=\"privacy\">\n  <ng-container *ngIf=\"!isGetContentFromAPI\">\n    <div [innerHTML]=\"content | safeHTML\"></div>\n  </ng-container>\n  <ng-container *ngIf=\"isGetContentFromAPI\">\n    <div *ngIf=\"contentFromAPI\" [innerHTML]=\"contentFromAPI | safeHTML\"></div>\n    <div *ngIf=\"!contentFromAPI\" class=\"loading-wrapper\">\n      <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\" />\n    </div>\n  </ng-container>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/service-and-privacy/service-and-privacy.component.html
// module id = 1085
// module chunks = 22